import React, { Suspense } from 'react';
import { Redirect, useRouteMatch } from 'react-router-dom';
import Spinner from 'components/Spinner/Spinner';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import CustomersRoutes from 'routes/customers';
import InvoicesRoutes from 'routes/invoices';
import OverviewRoutes from 'routes/overview';
import PassingsRoutes from 'routes/passings';
import PrivilegeRoutes from 'routes/privileges';
import ProfileRoutes from 'routes/profile';
import AccessManagementRoutes from './AccessManagement';
import { CUSTOMERS } from './customers/paths';
import HomeRoutes from './home';
import LocalAgreementsRoutes from './localAgreements';
import PRIVILEGE_GRANT_TOKEN from './privileges/paths';
const NoCustomerRedirect = () => {
  const {
    loading,
    customer
  } = useCurrentCustomer();
  const isPrivilegeGrantToken = useRouteMatch(PRIVILEGE_GRANT_TOKEN(':token'))?.isExact;
  if (isPrivilegeGrantToken) return null;
  if (!loading && !customer) return /*#__PURE__*/React.createElement(Redirect, {
    to: CUSTOMERS
  });
  return null;
};
function Routes() {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Spinner, null)
  }, /*#__PURE__*/React.createElement(NoCustomerRedirect, null), /*#__PURE__*/React.createElement(HomeRoutes, null), /*#__PURE__*/React.createElement(OverviewRoutes, null), /*#__PURE__*/React.createElement(InvoicesRoutes, null), /*#__PURE__*/React.createElement(LocalAgreementsRoutes, null), /*#__PURE__*/React.createElement(CustomersRoutes, null), /*#__PURE__*/React.createElement(ProfileRoutes, null), /*#__PURE__*/React.createElement(PrivilegeRoutes, null), /*#__PURE__*/React.createElement(AccessManagementRoutes, null), /*#__PURE__*/React.createElement(PassingsRoutes, null));
}
export default Routes;